export default function getkeycode(e) {
	e = e || window.event;
	return e.keyCode || e.which;
}